<template>
  <div>
    <PatientList
      :patients="patients"
      :totalDocs="totalDocs"
      :page="page"
      :shouldHideClinicSelector="shouldHideClinicSelector"
      :shouldUseLazyLoading="shouldUseLazyLoading"
      @fetchList="getPatientsList"
      @searchPatients="searchPatients"
      @viewPatientDetail="patientDetail"
      @clearResults="clearResults"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PatientList from '../../components/patients/List2';

export default {
  components: {
    PatientList,
  },
  data() {
    return {
      totalDocs: 0,
      page: 1,
      patients: [],
    };
  },
  computed: {
    nmdUserWithoutOrgs() {
      const user = this.$store.state.AppActiveUser;
      return user && 
             user.isNationalMedicalDirector && 
             (!user.doctorEMRClinics || user.doctorEMRClinics.length === 0) &&
             (!user.organizations || user.organizations.length === 0);
    },
    shouldHideClinicSelector() {
      return this.nmdUserWithoutOrgs;
    },
    shouldUseLazyLoading() {
      return this.nmdUserWithoutOrgs;
    },
  },
  methods: {
    ...mapActions('doctor', ['fetchEmrPatientsListFilter', 'searchEmrPatientsListFilter']),
    async getPatientsList(dataTableParams) {
      try {
        this.$vs.loading();
        const { data: { data } } = await this.fetchEmrPatientsListFilter(dataTableParams);
        this.patients = data;
        this.totalDocs = data.length;
        this.page = 1;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: 'Error',
          text: 'Error fetching patients',
          color: 'danger',
        });
      }
    },
    async searchPatients(dataTableParams) {
      try {
        this.$vs.loading();
        const {
          data: {
            data: { docs, pagination },
          },
        } = await this.searchEmrPatientsListFilter(dataTableParams);
        
        this.patients = docs;
        this.totalDocs = pagination.total || 0;
        this.page = pagination.page || 1;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: 'Error',
          text: 'Error fetching patients',
          color: 'danger',
        });
      }
    },
    patientDetail(id) {
      this.$router.push({
        name: 'DoctorPatientDetail',
        params: { patientId: id },
      });
    },
    clearResults() {
      this.patients = [];
      this.totalDocs = 0;
      this.page = 1;
    },
  },
};
</script>
